import styled, { css } from 'styled-components'

import * as colors from '../../constants/colors'
import * as icons from '../../svg/icons'
import * as copy from '../copy'

export type Status = 'selected' | 'disabled' | 'default'

export const BaseLabel = styled(copy.Text1)`
  display: inline;
  padding-right: 12px;
`

export const Label = styled(BaseLabel)<{ status?: Status }>`
  ${({ status }) => {
    if (status === 'disabled') {
      return css`
        opacity: 0.5;
      `
    }
    if (status === 'selected') {
      return css`
        font-weight: 600;
      `
    }
  }}
`

export const BaseSelectedIcon = styled(icons.Check).attrs({ size: 12 })`
  margin: 0 10px 0 0;
  stroke: ${colors.GRAY_3};
`

export const SelectedIcon = styled(BaseSelectedIcon)<{ status: Status }>`
  ${({ status }) => {
    if (status === 'selected') {
      return css`
        color: ${colors.GRAY_3};
      `
    }
    if (status === 'disabled' || status === 'default') {
      return css`
        display: none;
      `
    }
  }}
`

export const BaseWrapper = styled.li`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 15px;
  user-select: none;
  outline: none;
  cursor: pointer;
`

export const Wrapper = styled(BaseWrapper)<{ focused: boolean; filtered: boolean }>`
  ${({ focused }) => {
    if (focused) {
      return css`
        background-color: ${colors.SAND_2};
      `
    } else {
      return css`
        background-color: transparent;
      `
    }
  }}

  ${({ filtered }) => {
    if (filtered) {
      return css`
        /* don't use display:none keep width of dropdown even if largest item is filtered.
        Instead, reduce vertical dimension to 0 (height and padding) and hide overflow */
        visibility: hidden;
        height: 0;
        overflow: hidden;
        padding: 0 15px 0 15px;
      `
    }
  }}

   ${SelectedIcon} {
    flex: 0 0 12px;
  }
`
